export const MULTI_SELECTOR_LIMIT = 50;
